<template>
    <v-expansion-panels v-model="collapse">
        <v-expansion-panel>
            <v-expansion-panel-header><h3 class="font-weight-bold">{{ $t('common.filter.componentName') }}</h3></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-container fluid class="pt-0 pb-0">
                    <v-row>
                        <v-col cols="12" md="4">
                            <input-date-picker :setup.sync="datePickers.fromDate"></input-date-picker>
                        </v-col>

                        <v-col cols="12" md="4">
                            <input-date-picker :setup.sync="datePickers.toDate"></input-date-picker>
                        </v-col>

                        <v-col cols="12" md="4">
                            <input-select :setup.sync="selects.status"></input-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4">
                            <input-auto-complete :setup.sync="selects.part"></input-auto-complete>
                        </v-col>

                        <v-col cols="12" md="4">
                            <input-auto-complete v-if="selects.department.show" :setup.sync="selects.department"></input-auto-complete>
                        </v-col>

                        <v-col cols="12" md="4">
                            <input-auto-complete v-if="selects.client.show" :setup.sync="selects.client"></input-auto-complete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="4">
                            <div class="d-flex justify-end">
                                <v-btn
                                    color="error"
                                    class="mr-1"
                                    text
                                    small
                                    :disabled="!ready"
                                    @click="clearFilters"
                                >{{ $t('common.filter.clearFilter') }}</v-btn>
                                <v-btn
                                    color="primary"
                                    class="ml-1"
                                    small
                                    :disabled="!ready"
                                    @click="applyFilters"
                                >{{ $t('common.filter.applyFilter') }}</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import InputDatePicker from '@/components/InputDatePicker'
import InputAutoComplete from '@/components/InputAutoComplete'
import InputSelect from '@/components/InputSelect'

export default {
    name: 'contract-filter',
    props: ['filters'],
    components: {
        InputDatePicker,
        InputAutoComplete,
        InputSelect
    },
    data () {
        return {
            collapse: 1,
            ready: false,
            datePickers: {
                fromDate: {
                    label: this.$t('contracts.list.filter.fromDate'),
                    clearable: true,
                    dateFormatted: undefined
                },
                toDate: {
                    label: this.$t('contracts.list.filter.toDate'),
                    clearable: true,
                    dateFormatted: undefined
                }
            },
            selects: {
                part: {
                    label: this.$t('contracts.list.filter.part'),
                    text: 'name',
                    value: 'name',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: []
                },
                status: {
                    label: this.$t('contracts.list.filter.status'),
                    text: 'label',
                    value: 'value',
                    icon: 'feedback',
                    multiple: true,
                    clearable: true,
                    items: [
                        { value: 1, label: this.$t('contracts.status.items.draft') },
                        { value: 2, label: this.$t('contracts.status.items.signatures') },
                        { value: 3, label: this.$t('contracts.status.items.active') },
                        { value: 4, label: this.$t('contracts.status.items.renewal') },
                        { value: 5, label: this.$t('contracts.status.items.rescinded') },
                        { value: 6, label: this.$t('contracts.status.items.terminated') }
                    ],
                    selectedItems: []
                },
                client: {
                    label: this.$t('contracts.list.filter.client'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: [],
                    show: false
                },
                department: {
                    label: this.$t('contracts.list.filter.department'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: [],
                    show: false
                }
            },
            showInactives: false
        }
    },
    watch: {
        'filters.ready': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.ready = this.filters.ready
                }
            },
            deep: true
        },
        '$route': {
            handler: function (val, oldVal) {
                if (this.$route.name === 'Contratos') this.getAllContractPart()
            },
            deep: true
        }
    },
    mounted () {
        const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        this.type = currentUserCompany.client.type
        if (currentUserCompany.client.type !== 'department') {
            this.selects.department.show = true
            this.getAllDepartment()
            if (currentUserCompany.client.type === 'manager') {
                this.selects.client.show = true
                this.getAllClient()
            }
        }
        this.getAllContractPart()
    },
    methods: {
        async getAllClient () {
            this.selects.client.items = await this.$helpers.getAllClient(null, false, true)
        },
        async getAllContractPart () {
            this.selects.part.items = await this.$helpers.getAllContractPart()
        },
        async getAllDepartment () {
            this.selects.department.items = await this.$helpers.getAllClientTwo(true, 0, 'department')
        },
        filterCompanies () {
            for (const client of this.selects.client.items) {
                this.selects.client.selectedItems.push(client.objectId)
            }
            this.applyFilters()
        },
        applyFilters () {
            this.filters.fromDate = (this.datePickers.fromDate.dateFormatted) ? new Date(this.datePickers.fromDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString() : undefined
            this.filters.toDate = (this.datePickers.toDate.dateFormatted) ? new Date(this.datePickers.toDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString() : undefined
            this.filters.client = this.selects.client.selectedItems
            this.filters.department = this.selects.department.selectedItems
            // this.filters.manager = this.selects.manager.selectedItems
            this.filters.part = this.selects.part.selectedItems
            this.filters.status = this.selects.status.selectedItems
            this.filters.limit = undefined
            this.filters.skip = undefined
            this.$emit('get-data-from-api')
        },
        clearFilters () {
            this.filters.fromDate = undefined
            this.filters.toDate = undefined
            this.filters.client = []
            this.filters.part = []
            this.filters.status = []
            this.filters.limit = undefined
            this.filters.skip = undefined
            this.datePickers.fromDate.date = undefined
            this.datePickers.fromDate.dateFormatted = undefined
            this.datePickers.toDate.date = undefined
            this.datePickers.toDate.dateFormatted = undefined
            this.selects.part.selectedItems = []
            this.selects.status.selectedItems = []
            this.selects.client.selectedItems = []
            this.selects.department.selectedItems = []
            // this.selects.manager.selectedItems = []
            this.$emit('get-data-from-api')
        },
        toggleSelectItemStatus (select) {
            this.$nextTick(() => {
                if (select.selectedItems.length === select.items.length) {
                    select.selectedItems = []
                } else {
                    select.items.forEach((item) => {
                        if (select.selectedItems.indexOf(item.value) === -1) {
                            select.selectedItems.push(item.value)
                        }
                    })
                }
            })
        }
    }
}
</script>
